import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import AuthProvider from "../../auth/AuthProvider";
import { formatTitle } from "../../../utils/formatting";

function RelationForm() {
  return (
    <AuthProvider prefix={"relations"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          let title;
          // none of the fields in relation are required, so try companyName and fallback to firstname lastname
          if (model.companyName) {
            title = model.companyName;
          } else if (model.firstName && model.lastName) {
            title = `${model.firstName} ${model.lastName}`;
          }
          return formatTitle(this.pageTitle, title);
        }}
        endPoint={"core/relations"}
        pageTitle={getTranslation("relations.form.pageTitle", "Relatie")}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"tags.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default RelationForm;
